import styles from '~/shared/styles/Toggle.module.css'
import { ToggleProps } from '~/types/common.types'

export function Toggle({ value, onChange, label, disabled }: ToggleProps): React.ReactElement {
  return (
    <div className="flex items-center">
      <label className={`relative w-16 h-8 m-2 ml-0 inline-block ${disabled ? 'opacity-50' : ''}`}>
        <span className="sr-only">{label ? `${label} (${value ? 'On' : 'Off'})` : value ? 'On' : 'Off'}</span>
        <input
          checked={value}
          className="w-0 h-0 opacity-0"
          disabled={disabled}
          onChange={() => onChange(!value)}
          type="checkbox"
        />
        <span className={`${styles.slider} ${styles.round}`} />
      </label>
    </div>
  )
}
